const moneyFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatMoney = (value: number): string => `R$ ${moneyFormatter.format(value)}`;

export const formatMoneyInputValue = (value: number | undefined): string =>
  value === undefined ? "" : moneyFormatter.format(value);

export const parseMoneyInputValue = (value: string): number | undefined => {
  const cleaned = value.replace(/[^\d,.]/g, "");

  if (!cleaned) {
    return undefined;
  }

  const commaIndex = cleaned.lastIndexOf(",");
  const dotIndex = cleaned.lastIndexOf(".");
  const decimalSeparatorIndex = Math.max(commaIndex, dotIndex);

  const parsed =
    decimalSeparatorIndex === -1
      ? Number(cleaned)
      : parseWithDecimalSeparator(cleaned, decimalSeparatorIndex);

  return Number.isNaN(parsed) ? undefined : parsed;
};

const parseWithDecimalSeparator = (cleaned: string, decimalSeparatorIndex: number): number => {
  const integerPart = cleaned.slice(0, decimalSeparatorIndex).replace(/\D/g, "");
  const decimalPart = cleaned.slice(decimalSeparatorIndex + 1).replace(/\D/g, "");
  const hasDecimalPart = decimalPart.length > 0 && decimalPart.length <= 2;

  return hasDecimalPart
    ? Number(`${integerPart || "0"}.${decimalPart}`)
    : Number(cleaned.replace(/\D/g, ""));
};
